<template>
  <div>
    <Modal title="Give" @click.prevent="toggleModal">
      <div slot="body">
        <form @submit.prevent="submitForm">
          <fieldset>
            <!-- give form details -->
            <div v-if="!isConfirmDetails">
              <div class="row mt-4">
                <div class="form-group col-md-6 col-sm">
                  <label for="amount">Amount <span class="text-danger">*</span></label>
                  <input type="text" id="amount" placeholder="" class="form-control"
                    v-model="userDetails.amount">


                </div>

                <div class="form-group col-md-6 col-sm">
                  <label for="mass-time">Currency <span class="text-danger">*</span></label>
                  <select id="mass-time" class="form-control" @change="currencySelectedText">
                    <option v-for="(currency, currencyIndex) in countryCurrency"
                      :key="currencyIndex" :value= currency.id>{{currency.text}}</option>
                  </select>
                </div>

              </div>

              <div class="row">
                <div class="form-group col-md-6 col-sm">
                  <label for="give-for">Give For <span class="text-danger">*</span></label>
                  <select name="give-for" id="give-for" class="form-control"
                    @change="purposeSelectedText">
                    <option v-for="(purpose, purposeIndex) in givePurpose" :key="purposeIndex"
                      :value= purpose.id>{{purpose.text}}</option>
                  </select>
                </div>

                <div class="form-group col-md-6 col-sm">
                  <label for="email-address">Email Address <span
                      class="text-danger">*</span></label>
                  <input type="text" id="email-address" placeholder="e.g example@mail.com"
                    class="form-control" v-model="userDetails.email">
                </div>
              </div>


              <div class="row">
                <div class="form-group col-md-6 col-sm">
                  <label for="first-name">First name</label>
                  <input type="text" id="first-name" placeholder="" class="form-control"
                    v-model="userDetails.firstName">
                </div>

                <div class="form-group col-md-6 col-sm">
                  <label for="last-name">Last name</label>
                  <input type="text" id="last-name" placeholder="" class="form-control"
                    v-model="userDetails.lastName">
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6 col-sm">
                  <label for="phone-number">Phone Number</label>
                  <input type="text" id="phone-number" placeholder="" class="form-control"
                    v-model="userDetails.phoneNumber">
                </div>
              </div>

            </div>



            <!-- confirm details -->
            <div v-if="isConfirmDetails">
              <div class="text-center">
                <p class="confirm mt-2 font-weight-bold">Please confirm your details</p>
              </div>
              <div class="row mt-4">
                <div class="col-md-6">
                  <p class="font-weight-bold">Full Name:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.firstName}} {{userDetails.lastName}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p class="font-weight-bold">Amount:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.amount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p class="font-weight-bold">Currency:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.currency}}</p>
                </div>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <p class="font-weight-bold">Purpose:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.purpose}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p class="font-weight-bold">Email:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.email}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p class="font-weight-bold">Phone Number:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.phoneNumber}}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p class="font-weight-bold">Trans Ref:</p>
                </div>

                <div class="col-md-6">
                  <p>{{userDetails.transactionRef}}</p>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div v-if="!isConfirmDetails">
                <button type="button" class="btn btn-secondary mr-3"
                  @click="toggleModal">Close</button>

                <button type="button" class="btn-jscc-sm"
                  @click.prevent="giveDetails">Give</button>
              </div>

              <div v-if="isConfirmDetails">
                <button type="button" class="btn btn-secondary mr-3"
                  @click.prevent="editDetails">Back</button>

                <button type="button" class="btn-jscc-sm btn-proceed"
                  @click.prevent="submitDetails">Proceed</button>

              </div>


            </div>

          </fieldset>
        </form>

      </div>
    </Modal>
    <!-- <BarSpinner></BarSpinner> -->
  </div>
</template>

<script>
import axios from 'axios';
import Modal from '@/components/modal/Modal.vue';
import BarSpinner from '@/components/spinners/BarSpinner.vue';
export default {
  data() {
    return {
      isConfirmDetails: false,
      userDetails: {
        firstName: '',
        lastName: '',
        email: '',
        purpose: this.purposeSelectedText,
        phoneNumber: '',
        amount: '',
        transactionRef: `GVJSSC-${this.generateTransNumber()}`,
        currency: this.currencySelectedText
      },
      givePurpose: [{
          id: '',
          text: 'Select purpose'
        },
        {
          id: 1,
          text: 'Tithe'
        },
        {
          id: 2,
          text: 'Parish Project'
        },
        {
          id: 3,
          text: 'Silent Giving'
        },
        {
          id: 4,
          text: 'Harvest'
        },
        {
          id: 5,
          text: 'Support Of Parish Evagelization'
        },
        {
          id: 6,
          text: 'Bulletin Sponsorship'
        },
        {
          id: 7,
          text: 'Church Building'
        },
        {
          id: 8,
          text: 'Sacrificial Offering'
        }
      ],
      countryCurrency: [{
          id: '',
          text: 'Select currency'
        },
        {
          id: 1,
          text: 'NGN'
        },
        {
          id: 2,
          text: 'USD'
        },

        {
          id: 3,
          text: 'KES'
        },
        {
          id: 4,
          text: 'GHS'
        },
        {
          id: 5,
          text: 'UGX'
        },
        {
          id: 6,
          text: 'TZS'
        },

        {
          id: 7,
          text: 'ZAR'
        }
      ]
    }
  },
  components: {
    Modal,
    BarSpinner
  },
  methods: {
    giveDetails() {
      this.isConfirmDetails = true
    },
    editDetails() {
      this.isConfirmDetails = false
    },

    async submitDetails() {
      try {
         let btnProceed = document.querySelector('.btn-proceed');
          btnProceed.innerHTML = `<i class="fa fa-spinner fa-spin">`
          btnProceed.disabled = true;

        const response = await axios.post(`/payment/donations`, JSON.stringify(this
          .userDetails));
        const data = await response;
        window.location.href = data.data.link

      } catch (error) {
        console.error("error", error);
      }
    },
    toggleModal() {
      this.$emit('close')
      this.userDetails.amount = ''
      this.userDetails.email = ''
      this.userDetails.firstName = ''
      this.userDetails.lastName = ''
      this.userDetails.phoneNumber = ''
      this.userDetails.currency = ''
      this.userDetails.purpose = ''
    },

    currencySelectedText(event) {
      const options = event.target.options;
      const selectedOption = options[options.selectedIndex];

      this.userDetails.currency = selectedOption.textContent;
    },
    purposeSelectedText(event) {
      const options = event.target.options;
      const selectedOption = options[options.selectedIndex];

      this.userDetails.purpose = selectedOption.textContent;
    },
    generateTransNumber() {
      return 'xxxx-5xxx-yxxx-xxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 10 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(10);
      });
    }
  }
}


</script>

<style scoped>
.confirm {
  color: #0A2463
}

.form-group input:focus,  .form-group select:focus{
  outline: 0px !important;
  box-shadow: none !important;
}

.btn-jscc-sm {
  padding: .56rem .8rem !important;
  line-height: 1.5rem !important;
  font-size: 1rem !important;
  font-weight: 400;
}

</style>
